import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AuthProvider } from 'providers/auth/auth';
import firebase from 'firebase';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any;
  pages: Array<{title: string, component: any, icon: string}>;
  
  constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, 
    public auth: AuthProvider) {
    this.pages = [
      { title: 'Home Page', component: 'HomePage', icon: 'home' },
      { title: 'Profile', component: 'ProfilePage', icon: 'person' },
      { title: 'Sign Out', component: '', icon: 'log-out' },
    ]
    this.initializeApp(auth);
    
  }

  initializeApp(firebaseAuth: AuthProvider) {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      firebaseAuth.init();
      const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
        if (!user) {
          this.rootPage = 'LoginPage';
          unsubscribe();
        } else {
          this.rootPage = 'HomePage';
          unsubscribe();
        }
      });
      
     
    });
  }
  logoutUser() {
    firebase.auth().signOut()
      .then(()=> {
        this.nav.setRoot('LoginPage');
      },(error) => {
        console.log(error)
      })
  }
  openPage(page) {
    console.log('page: ' + page.title);
    if(page.title == 'Sign Out') {
      console.log('user logout');
      this.logoutUser();
    } else {
      this.nav.setRoot(page.component);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts